import React from 'react';
import { Users, Shield, Hotel, Wrench, ClipboardCheck, FileCheck, HardHat, Briefcase } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const Services = () => {
  const services = [
    {
      icon: Users,
      title: 'Manpower Supply',
      description: 'Skilled and unskilled workforce solutions tailored to your business needs',
      features: ['Skilled Workers', 'Unskilled Labor', 'Temporary Staffing', 'Permanent Placement']
    },
    {
      icon: Shield,
      title: 'Security Services',
      description: 'Comprehensive security solutions with trained and licensed personnel',
      features: ['Security Guards', 'Armed Security', 'Corporate Security', '24/7 Surveillance']
    },
    {
      icon: Hotel,
      title: 'Hospitality Staff',
      description: 'Professional hospitality services for corporate and residential needs',
      features: ['Housekeeping', 'Pantry Services', 'Office Support', 'Facility Management']
    },
    {
      icon: Wrench,
      title: 'Technical Services',
      description: 'Expert technical workforce for infrastructure and maintenance projects',
      features: ['Civil Works', 'Mechanical', 'Electrical', 'AMC Services']
    },
    {
      icon: ClipboardCheck,
      title: 'HR & Payroll',
      description: 'Complete HR management and payroll processing solutions',
      features: ['Payroll Management', 'HR Consulting', 'Attendance Systems', 'Performance Tracking']
    },
    {
      icon: FileCheck,
      title: 'Compliance Services',
      description: 'Full labor law compliance and statutory management',
      features: ['PF & ESIC', 'Labor Laws', 'Factory Compliance', 'Legal Documentation']
    },
    {
      icon: HardHat,
      title: 'Project Contracts',
      description: 'Turnkey project solutions for infrastructure development',
      features: ['Erection & Commissioning', 'Infrastructure Projects', 'Contract Staffing', 'Project Management']
    },
    {
      icon: Briefcase,
      title: 'Management Services',
      description: 'Professional management staff for various organizational roles',
      features: ['Management Staff', 'Admin Support', 'Operations Team', 'Supervisory Staff']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-slate-50 to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive workforce solutions designed to meet your business requirements
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 hover:scale-105 border-2 border-gray-100 hover:border-blue-200 bg-white"
              >
                <CardHeader>
                  <div className="flex items-center justify-center w-14 h-14 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-xl mb-4 group-hover:from-blue-600 group-hover:to-cyan-600 transition-all duration-300">
                    <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">{service.title}</CardTitle>
                  <CardDescription className="text-gray-600">{service.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-600">
                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-2"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;